










import { mapGetters } from 'vuex';

export default {
	name: 'JobOrderBy',

	setup() {
		const orderBy = ref('created_at');
		const orderDir = ref('desc');

		const options = reactive([
			{ text: 'Title', value: 'title' },
			{ text: 'Created On', value: 'created_at' },
		]);

		return { orderBy, orderDir, options };
	},

	computed: {
		directionDesc() {
			return this.orderDir === 'desc';
		},
		...mapGetters('jobs', {
			currentOrderBy: 'getOrder',
		}),
	},

	watch: {
		orderBy() {
			this.setOrderBy();
		},
	},

	methods: {
		setOrderDir() {
			if (this.directionDesc) this.orderDir = 'asc';
			else this.orderDir = 'desc';

			this.setOrderBy();
		},

		async setOrderBy() {
			await this.$store.dispatch('jobs/setOrder', {
				order_by: this.orderBy,
				order_dir: this.orderDir,
			});

			await this.$store.dispatch('jobs/getFilteredCompanyJobs');
		},
	},
};
